import styled from 'styled-components';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 520px;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Input = styled.input`
  padding: 0.5rem 0.65rem;
  font-size: 0.9rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-weight: 400;
`;

export const TextArea = styled.textarea`
  padding: 0.5rem 0.65rem;
  font-size: 0.9rem;
  min-height: 72px;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-weight: 400;
  font-family: inherit;
  resize: vertical;
`;

export const Intro = styled.p`
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const Pill = styled.button<{ $active: boolean }>`
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  background: ${({ $active, theme }) =>
    $active ? `${theme.colors.primary}12` : theme.colors.background};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  cursor: pointer;
`;

export const ErrorText = styled.span`
  font-size: 0.8rem;
  color: #b71c1c;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 0.5rem;
`;
